import Nullstack from 'nullstack';

class FacebookPixel extends Nullstack {

  static hash = '21f3465d5d6fb879e77fd1f3cefa4dfb';

  async hydrate({ page, id }) {
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod
          ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    }(window, document, 'script',
      'https://connect.facebook.net/en_US/fbevents.js'));
    fbq('init', id);
    fbq('track', 'PageView');
    window.addEventListener(page.event, () => {
      fbq('init', id);
      fbq('track', 'PageView');
    });
  }

}

export default FacebookPixel;
if (module.hot) { module.hot.accept(); Nullstack.updateInstancesPrototypes(FacebookPixel, FacebookPixel.hash, 'd41d8cd98f00b204e9800998ecf8427e') }